'use client';
import { useState } from 'react';
import styles from './index.module.scss';
import { textTran } from './config';
import { sendEmarsysEmail } from './apis';
import getLocal from '@/app/utils/getLocal';
import { useGlobal } from '@/utils/useGlobal';
import { subscribeCookie } from '@/utils/cookies/subscribeCookie';

interface fieldsType {
    id: string;
    type: string;
    value: number | number[];
    overwrite: boolean;
}
interface tipsType {
    btnText?: string;
    placeholder?: string;
    tipsEmpty?: string;
    tipsTypeError?: string;
    successTips?: string;
}
const getFieldsList = ({ fields, fieldId, fieldValue }: any) => {
    // 这个逻辑不正确
    // if (fieldId && fieldValue) {
    //     return [
    //         {
    //             id: fieldId,
    //             overwrite: true,
    //             type: 'single',
    //             value: fieldValue,
    //         },
    //     ];
    // }
    if (fields) {
        return fields;
    }
    return false;
};
export default function EditorEmarsysEmail({
    contactListId,
    fields,
    fieldId,
    fieldValue,
    email = '',
    className,
    callback,
    tipsObj = {},
    needTerms = false,
    a1 = '',
    a2 = '',
    langKey = '',
}: {
    contactListId: string;
    fields?: string | fieldsType[];
    fieldId?: string;
    fieldValue?: number;
    email?: string;
    className?: string;
    callback?: any;
    tipsObj?: tipsType;
    needTerms?: boolean;
    a1?: string;
    a2?: string;
    langKey?: string;
}) {
    const { locale } = getLocal();
    const textObj = textTran[locale] || textTran['us'];
    const { useLang } = useGlobal();
    const { t } = useLang(langKey);
    const [check, setCheck] = useState(['uk', 'eu', 'de', 'fr', 'it', 'es']?.includes(locale));
    const [value, setValue] = useState(email || ''); //输入框值
    const [tipsMsg, setTipsMsg] = useState<string | undefined>(); // 提示语文案
    const [tipsType, setTipsType] = useState<string>(''); // 提示类型
    const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
    // 邮箱校验
    const fields2 = getFieldsList({
        fields,
        fieldId,
        fieldValue,
    });
    // 提示语
    const tipsObj2: tipsType = {
        successTips: tipsObj.successTips || textObj.successTips,
        btnText: tipsObj.btnText || textObj.btnText, // 文案--提交按钮
        placeholder: tipsObj.placeholder || textObj.placeholder, // 文案--输入框提示语
        tipsEmpty: tipsObj.tipsEmpty || textObj.tipsEmpty, // 文案--空时提示语
        tipsTypeError: tipsObj.tipsTypeError || textObj.tipsTypeError, // 文案--格式不对
        tipsCheck: tipsObj.tipsCheck || textObj.tipsCheck,
    };

    // 输入值变化
    const changeHandle = (e: any) => {
        const val = e.target.value;
        setValue(val);
        setTipsMsg('');
    };

    const handleCheck = (e: any) => {
        setCheck(e.target.checked);
        if (tipsMsg === tipsObj2.tipsCheck && e.target.check) {
            setTipsMsg('');
        }
    };

    const handleFocus = () => {
        if (tipsMsg && tipsMsg !== tipsObj2.tipsCheck) {
            setTipsMsg('');
        }
    };

    // 点击
    const clickHandle = async () => {
        const value2 = value.trim();
        // 非空校验
        if (!value2) {
            setTipsType('error');
            return setTipsMsg(tipsObj2.tipsEmpty);
        }
        // 格式校验
        if (!emailRegex.test(value2)) {
            setTipsType('error');
            return setTipsMsg(tipsObj2.tipsTypeError);
        }
        // 必须有传值
        if (!contactListId || !fields2) {
            return null;
        }
        if (needTerms && !check) {
            return setTipsMsg(tipsObj2.tipsCheck);
        }
        const data = {
            email: value2,
            contactListId: contactListId,
            fields: fields2,
        };
        await sendEmailHandle(data);
    };
    // 执行发送
    const sendEmailHandle = async (data: any) => {
        const res: any = await sendEmarsysEmail(
            locale,
            data,
            subscribeCookie({
                sector_name: t('tipsObj2.btnText'),
                entry_position: 0,
            }),
        );
        if (res.code === '0') {
            setTipsMsg(tipsObj2.successTips); //成功
            setTipsType('success');
            callback && callback('success');
            setValue('');
        } else {
            setTipsType('error');
            setTipsMsg(res.message || 'fail'); // 后台接口提示
            callback && callback('fail');
        }
    };
    return (
        <div className={`${styles.EditorEmarsysEmail} EditorEmarsysEmail-type-${tipsType} EditorEmarsysEmail ${className}`}>
            <div className="EditorEmarsysEmail-in">
                <div className="EditorEmarsysEmail-c">
                    <input
                        type="text"
                        className="EditorEmarsysEmail-input"
                        value={value}
                        onChange={changeHandle}
                        onFocus={handleFocus}
                        placeholder={tipsObj2.placeholder}
                    />
                </div>
                <div className="EditorEmarsysEmail-r" onClick={clickHandle}>
                    {tipsObj2.btnText}
                </div>
            </div>
            <div className="EditorEmarsysEmail-errors">{tipsMsg}</div>
            {needTerms && (
                <div className="terms">
                    <input id="editor-email-checkbox" type="checkbox" className="checkbox" value={check} onChange={handleCheck} />
                    <label htmlFor="editor-email-checkbox" className="terms-text">
                        {t.rich('box_terms', {
                            a1: (c: string) => (
                                <a href={a1} className="link" target="_blank" rel="noreferrer">
                                    {c}
                                </a>
                            ),
                            a2: (c: string) => (
                                <a href={a2} className="link" target="_blank" rel="noreferrer">
                                    {c}
                                </a>
                            ),
                        })}
                    </label>
                </div>
            )}
        </div>
    );
}
